import { useQuery } from "react-query";

import { getScreenPermissions } from "@/api/App/Permissions/permissions-api";
import { hasPermission } from "@/services/Utils";

export function useScreenPermissions(screenId, options = {}) {
	const queryResult = useQuery(["screen-permissions", screenId], () => getScreenPermissions(screenId), {
		enabled: Boolean(screenId),
		staleTime: 5 * 60 * 1000,
		...options,
	});

	const permissions = queryResult.data?.permissions || [];

	return {
		...queryResult,
		permissions,
		canShow: hasPermission("show", permissions),
		canCreate: hasPermission("create", permissions),
		canEdit: hasPermission("edit", permissions),
		canDelete: hasPermission("delete", permissions),
		canApprove: hasPermission("approve", permissions),
	};
}
